import React, { useEffect } from "react";
import { useLanguage } from "../lib/language";
import { translations } from "../lib/translations";

export function PrivacyPolicyPage() {
  const { language } = useLanguage();
  const t = translations;

  useEffect(() => {
    // Scroll to top immediately
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    // Also ensure scroll to top after a small delay in case content is still loading
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            {t.privacyPolicyTitle[language]}
          </h1>

          <p className="text-sm text-gray-600 mb-8">
            {t.privacyPolicyLastUpdated[language]}
          </p>

          <div className="space-y-8">
            <div>
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.privacyPolicyIntro[language]}
              </p>
            </div>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.privacyPolicySection1Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.privacyPolicySection1Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.privacyPolicySection2Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.privacyPolicySection2Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.privacyPolicySection3Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.privacyPolicySection3Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.privacyPolicySection4Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.privacyPolicySection4Content[language]}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                {t.privacyPolicySection5Title[language]}
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                {t.privacyPolicySection5Content[language]}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
